import {getQueryString} from './shared';

const createPopup = ({screen, window}) => {
  let popup = null;

  const getFeatures = () => {
    const w = 768;
    const h = 700;
    const x = Math.round((screen.width / 2) - (w / 2));
    const y = Math.round((screen.height / 2) - (h / 2));

    return `left=${x},top=${y},width=${w},height=${h},personalbar=no,toolbar=no,scrollbars=yes,location=yes,resizable=yes`;
  }

  return {
    save(url) {
      const query = getQueryString({url});
      popup = window.open(`/v1/popup?${query}`, "pktbtn_login", getFeatures());
      popup.focus();
      return this;
    },
    close() {
      popup.close();
    }
  }
};

export {createPopup};
